import React, { useState, useEffect } from "react";
import {
  Card,
  Container,
  CardBody,
  CardSubtitle,
  CardTitle,
  CardText,
  Button,
  ModalBody,
  Modal,
} from "reactstrap";
import TuneIcon from "@mui/icons-material/Tune";
import { DataGrid } from "@mui/x-data-grid";
import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import { Autocomplete, Checkbox } from "@mui/material";
import { TextField } from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import ReplayIcon from "@mui/icons-material/Replay";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { styled } from "@mui/system";
import {
  Unstable_NumberInput as BaseNumberInput,
  numberInputClasses,
} from "@mui/base/Unstable_NumberInput";
import { useNavigate } from "react-router-dom";
import {
  purchase_manager_pending_product_approval_list,
  purchase_product_wise_saved_approval,getStockInHand,
  managementApprovalPendingList,
  submitManagementApproval
} from "../../../api/requisition";
import { toast } from "react-toastify";
import { useApprovalFilter } from "../../../Components/Hooks/UseApprovalFilter";
import { pendingApprovalList } from "../../../api/approval";
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import { useDispatch } from "react-redux";
import { StorePageHeaderName } from "../../../store/pageHeader/action";
import VisibilityIcon from '@mui/icons-material/Visibility';
import SweetAlert from "react-bootstrap-sweetalert";



const ApprovalPending = ({ approvalDetails }) => {

  const dispatch = useDispatch();
  dispatch(StorePageHeaderName('Pending Approval'))

  const navigate = useNavigate();
  
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [approvalRows, setApprovalRows] = useState([]);
  const [checkedRows, setCheckedRows] = useState([]);
  const [gridLoad, setGridLoad] = useState(false);
  const [mergedArray, setMergedArray] = useState(null);
  const [open, setOpen] = useState(false)
  const [isOpenSweetAlert, setIsOpenSweetAlert] = useState(false);
  const [isLoading, setIsLoading] = useState(false);



  const openModal = () => {
    setModalIsOpen(true);
  };
  const closeModal = () => {
    setModalIsOpen(false);
  };
  document.title = "Pending approvals";

  const [showList, setShowList] = useState(false);

  const toggleList = () => {
    setShowList(!showList);
  };


  const handleCheckboxChange = (event, params) => {
    const isChecked = event.target.checked;
    const row = params.row; // Get the entire row object

    if (isChecked) {
      setCheckedRows((prevRows) => [...prevRows, row]);
    } else {
      const updatedRows = checkedRows.filter(
        (checkedRow) => checkedRow.id !== row.id
      );
      setCheckedRows(updatedRows);
    }
  };

  const handleSelectAllCheckboxChange = (event) => {
    const isChecked = event.target.checked;

    if (isChecked) {
      setCheckedRows([...approvalRows]);
    } else {
      // const updatedRows = checkedRows.filter(checkedRow => checkedRow.id !== row.id);
      setCheckedRows([]);
    }
  };

  const columns = [
    {
      field: "Sl_No",
      headerName: (
        <div style={{ display: "flex", alignItems: "center" }}>
        <Checkbox
          checked={
            checkedRows.length > 0 &&
            checkedRows.length === approvalRows.length
          } // 'checkedRows' is your array of selected rows, 'rows' is your data array
          onChange={handleSelectAllCheckboxChange} // Define a function to handle 'select all' checkbox change
          indeterminate={
            checkedRows.length > 0 &&
            checkedRows.length < approvalRows.length
          } // Show indeterminate state if some but not all are selected
          inputProps={{ "aria-label": "Select All" }}
        />
        <span>Sl No.</span>
        </div>
      ),
      sortable: false,
      resizable: false,
      width: 100,
      renderCell: (params) => {
        return (
          <div style={{ display: "flex", alignItems: "center" }}>
            <Checkbox
              checked={
                checkedRows.length > 0 &&
                checkedRows.some(
                  (checkedRow) => checkedRow.id === params.row.id
                )
              }
              onChange={(event) => handleCheckboxChange(event, params)}
            />

            <span>{params.row.Sl_No}</span>
          </div>
        );
      },
    },
    {
        field: "segment",
        headerName: "Segment",
        headerClassName: "table-header-background",
        headerAlign: "center",
        cellClassName: "center-aligndata",
        editable: false,
        resizable: false,
        sortable: false,
        flex: 1,
      },
      {
        field: "category",
        headerName: "Category",
        headerClassName: "table-header-background",
        headerAlign: "center",
        cellClassName: "center-aligndata",
        editable: false,
        resizable: false,
        sortable: false,
        flex: 1,
      },
      {
        field: "vertical",
        headerName: "Vertical",
        headerClassName: "table-header-background",
        headerAlign: "center",
        cellClassName: "center-aligndata",
        editable: false,
        resizable: false,
        sortable: false,
        flex: 1,
      },
      {
        field: "product_name",
        headerName: "Product Name",
        headerClassName: "break-header",
        cellClassName: "product_name_wrap",
        width: 160,
        editable: false,
        resizable: false,
        sortable: false,
        flex: 1,
      },
      {
        field: "req_qty",
        headerName: "PO QTY",
        headerClassName: "table-header-background",
        sortable: false,
        resizable: false,
        headerAlign: "center",
        cellClassName: "center-aligndata",
        flex: 1,
      },
      {
        field: "value",
        headerName: "Value",
        headerClassName: "table-header-background",
        sortable: false,
        resizable: false,
        headerAlign: "center",
        cellClassName: "center-aligndata",
        flex: 1,
      },
  ];
  
  const blue = {
    100: "#DAECFF",
    200: "#80BFFF",
    400: "#3399FF",
    500: "#007FFF",
    600: "#0072E5",
    700: "#0059B2",
  };

  const grey = {
    50: "#F3F6F9",
    100: "#E5EAF2",
    200: "#DAE2ED",
    300: "#C7D0DD",
    400: "#B0B8C4",
    500: "#9DA8B7",
    600: "#6B7A90",
    700: "#434D5B",
    800: "#303740",
    900: "#1C2025",
  };

  const StyledInputRoot = styled("div")(
    ({ theme }) => `
            font-family: 'IBM Plex Sans', sans-serif;
            font-weight: 400;
            border-radius: 4px;
            color: #0060AA;
            background: transparent;
            border: 1px solid #0060AA;
            box-shadow: 0px 2px 4px ${
              theme.palette.mode === "dark"
                ? "rgba(0,0,0, 0.5)"
                : "rgba(0,0,0, 0.05)"
            };
            display: grid;
            grid-template-columns: 1fr 19px;
            grid-template-rows: 1fr 1fr;
            overflow: hidden;
            column-gap: 8px;
            padding: 3px 4px;

            &.${numberInputClasses.focused} {
              border-color: #0060AA;
            }

            &:hover {
              border-color: #0060AA;
            }

            // firefox
            &:focus-visible {
              outline: 0;
            }
          `
  );

  const StyledInputElement = styled("input")(
    ({ theme }) => `
            font-size: 1rem;
            font-family: inherit;
            font-weight: 400;
            line-height: 1.5;
            grid-column: 1/2;
            grid-row: 1/3;
            color: ${theme.palette.mode === "dark" ? grey[300] : grey[900]};
            background: inherit;
            border: none;
            border-radius: inherit;
            padding: 2px 12px;
            outline: 0;
          `
  );

  const StyledButton = styled("button")(
    ({ theme }) => `
            display: flex;
            flex-flow: row nowrap;
            justify-content: center;
            align-items: center;
            appearance: none;
            padding: 0;
            width: 0px;
            height: 19px;
            font-family: system-ui, sans-serif;
            font-size: 0.875rem;
            line-height: 1;
            box-sizing: border-box;
            background: ${theme.palette.mode === "dark" ? grey[900] : "#fff"};
            border: 0;
            color: ${theme.palette.mode === "dark" ? grey[300] : grey[900]};
            transition-property: all;
            transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
            transition-duration: 120ms;

            &:hover {
              background: ${
                theme.palette.mode === "dark" ? grey[800] : grey[50]
              };
              border-color: ${
                theme.palette.mode === "dark" ? grey[600] : grey[300]
              };
              cursor: pointer;
            }

            &.${numberInputClasses.incrementButton} {
              grid-column: 2/3;
              grid-row: 1/2;
              border-top-left-radius: 4px;
              border-top-right-radius: 4px;
              border: 1px solid;
              border-bottom: 0;
              border-color: transparent;
              background: transparent;
              color: #0060AA;

              &:hover {
                cursor: pointer;
                color: #0060AA;
                background: transparent;
                border-color:transparent;
              }
            }

            &.${numberInputClasses.decrementButton} {
              grid-column: 2/3;
              grid-row: 2/3;
              border-bottom-left-radius: 4px;
              border-bottom-right-radius: 4px;
              border: 1px solid;
              border-color:transparent;
              background: transparent;
              color: #0060AA;
            }

            &:hover {
              cursor: pointer;
              color: #0060AA;
              background: transparent;
              border-color: transparent;
            }

            & .arrow {
              transform: translateY(-1px);
            }

            & .arrow {
              transform: translateY(-1px);
            }
          `,
    );
    const CustomNumberInput = React.forwardRef(function CustomNumberInput(props, ref) {
        return (
            <BaseNumberInput
                slots={{
                    root: StyledInputRoot,
                    input: StyledInputElement,
                    incrementButton: StyledButton,
                    decrementButton: StyledButton,
                }}
                slotProps={{
                    incrementButton: {
                        children: '▴',
                    },
                    decrementButton: {
                        children: '▾',
                    },
                }}
                {...props}
                ref={ref}
            />
        );
    });

    const handleSubmitApproval = async () => {
        try {

            if(checkedRows.length == 0){
                toast.error("Fill all the required fields!");
                return;
            }

            const payload = {
                product_dist_id: checkedRows.map(el => el.id)
            };
            
            setIsLoading(true)
            const response = await submitManagementApproval(payload);


            if(response.statusCode === 200) {
 
             setIsOpenSweetAlert(true);
             approvalDetailsList();
            }
 

        }
        catch (e){
            console.log(e)
            toast.error('Error in creating Purchase requisition')
        }
        finally {
            setIsLoading(false); // Reset loading state after operation completes
        }
    };

    const approvalDetailsList = async () => {
        try {
          setGridLoad(true);
          const response = await managementApprovalPendingList(approvalDetails.id);
          const data = response.data.requisitionProductList.map((item, index) => ({
            id: item.id,
            sl_no: index + 1,
            segment: item.itemseg,
            category: item.category,
            vertical: item.vertical,
            product_name: item.item_name,
            req_qty: Number(item.approve_quantity),
            value: +(item.mop * item.approve_quantity * item.conversion_rate),
          }));
          
          setApprovalRows(data);
        } catch (error) {
          toast.error(
            error.message || "An error occurred while fetching detailed list"
          );
        } finally {
          setGridLoad(false);
        }
      };


    useEffect (()=>{
        approvalDetailsList()
    },[])

    const handleSweetAlertConfirm = () => {
        setIsOpenSweetAlert(false);

    };
    
  return (
    <React.Fragment>
        
      <Container fluid>
        <div>
          <div
            style={{
              display: "flex",
              justifyContent: "end",
              alignItems: "center",
              marginTop: "10px",
              flexWrap: "wrap",
            }}
          >
            {/* <div style={{ fontSize: "20px" }}>
              <h4 className="mb-0 requisition_text">
                Approval Requisition History
              </h4>
            </div> */}
            <div className="d-flex align-items-center">
              
              <div className="ms-2">
                <button
                  className="save_button"
                  onClick={() => handleSubmitApproval()}
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
          

          <Box
            sx={{
              height: '100%',
              width: "100%",
              marginBottom: "10px",
              marginTop: "10px",
            }}
          >
            <DataGrid
               autoHeight
              className="table_header_background"
              headerClassName="custom-header-cell"
              rows={approvalRows}
              columns={columns}
              loading={gridLoad}
              // initialState={{
              //     pagination: {
              //         paginationModel: {
              //             pageSize: 5,
              //         },
              //     },
              // }}
              pageSizeOptions={[]}
              disableRowSelectionOnClick
              disableColumnMenu
              componentsProps={{
                cell: {
                  disableClick: true,
                },
              }}
              sx={{
                "& .MuiDataGrid-cell": {
                  "& .MuiDataGrid-cell--textOverflow": {
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  },
                },
              }}
            />
          </Box>
        </div>
        <Card>
                        <CardBody>
                            <div>
                                <table id="table" className='requisition_balance'>
                                    <thead className='booked_balance_listHeader'>
                                        <tr>
                                            <th className="text-center">Item Count</th>
                                            <th className="text-center">Total Quantity</th>
                                            <th className="text-center">Total Value</th>
                                        </tr>
                                    </thead>
                                    <tbody className='requisition_balance_table_body'>
                                        
                                            <tr>
                                                <td className="text-center">{checkedRows.length}</td>
                                                <td className="text-center">{checkedRows.reduce((accumulator, currentObject) => {
                                                  return accumulator + currentObject.req_qty;
                                                }, 0)}</td>
                                                <td className="text-center">{checkedRows.reduce((accumulator, currentObject) => {
                                                  return accumulator + currentObject.value;
                                                }, 0)}</td>
                                                
                                            </tr>
                                        
                                    </tbody>
                                    {/* <tfoot className='requisition_balance_footer'>
                                        <tr>
                                            <th id="total" colSpan="2">Total :</th>
                                            <td>{totalQuantity}</td>
                                            <td>{formatValueWithCommas(totalValue)}</td>
                                        </tr>
                                    </tfoot> */}
                                </table>
                            </div>
                        </CardBody>
                    </Card>
      </Container>
      {/* <Modal
               className="approval_requisiton_modal modal_box "
                isOpen={modalIsOpen}
                onRequestClose={closeModal}
                contentLabel="Example Modal"
            >
                <div className='d-flex justify-content-between me-2 mt-3'>
                    <h3 className='ms-3'>HOBS-HB-MARICA 3BT 60 DLX-RETAIL</h3>
                    <div className='d-flex justify-content-end me-3 modal_close'>
                        <i class="ri-close-line" onClick={closeModal}></i>
                    </div>
                </div>
                <hr className='mb-2 mt-1 ms-3 me-3'></hr>
                <ModalBody className='pt-2'>
                    <div>
                    <div style={{ display: 'flex', gap: '16px', marginBottom: '16px', }}>
                            <div>
                                <TextField
                                   className="addrequisiton_field"
                                    // id={`value-${index}`}
                                    label="Executive Name"
                                    variant="outlined"
                                    // value={row.value}
                                    // onChange={(event) => handleInputChange(index, 'value', event.target.value)}
                                    sx={{ width: 160 }} // Increase size
                                />
                            </div>
                            <div>
                                <CustomNumberInput sx={{ width: '260px' }} aria-label="Demo number input" placeholder="Quantity" />
                            </div>
                            {clickOnEdit &&
                            <div>
                                <CustomNumberInput sx={{ width: '260px' }} aria-label="Demo number input" placeholder="Allocation Quantity" />
                            </div>
                              }
                            <div>
                                <Button className="save_button">Save</Button>
                            </div>
                            <div>
                            <Button className="approval_edit" onClick={()=> {setClickOnEdit(true)}}>Edit</Button>
                            </div>
                        </div>
                    </div>
                    <hr></hr>
                    {rows.map((row, index) => (
                        <>
                        <div key={index} style={{ display: 'flex', gap: '16px', marginBottom: '16px', }}>
                            <div>
                                <TextField
                                   className="addrequisiton_field"
                                    id={`value-${index}`}
                                    label="Executive Name"
                                    variant="outlined"
                                    value={row.value}
                                    onChange={(event) => handleInputChange(index, 'value', event.target.value)}
                                    sx={{ width: 300 }} // Increase size
                                />
                            </div>
                            <div>
                                <CustomNumberInput sx={{ width: '200px' }} aria-label="Demo number input" placeholder="Quantity" />
                            </div>
                            <div>
                                <Button className="approval_edit">Edit</Button>
                            </div>
                            <div>
                                <Button className="approval_edit">Save</Button>
                            </div>
                        </div>
                        <hr></hr>
                        </>
                    ))}
                    <button className="add_more_button" onClick={handleAddRow}>+ Add More</button>
                    <div className='d-flex align-items-center mt-4 justify-content-center'>
                        <button className="yes_button d-flex align-items-center">
                            Done
                        </button>
                    </div>
                </ModalBody>
            </Modal> */}
            <SweetAlert
                show={isOpenSweetAlert}
                title='Requisitions Approved'
                success
                confirmButtonText="Ok"
                confirmBtnBsStyle="success"
                onConfirm={handleSweetAlertConfirm} // Updated to handleSweetAlertConfirm function

            />
    </React.Fragment>
  );
};

export default ApprovalPending;
